export const sharePdf = (data, base64Pdf) => {
  try {
    var pdfBase64String = data + base64Pdf;

    var options = {
      files: [pdfBase64String], // an array of filenames either locally or remotely
      chooserTitle: 'teste.pdf'
    };

    window.plugins.socialsharing.shareWithOptions(options);
  } catch (err) {
    alert(err.message);
  }
}
